import { render, staticRenderFns } from "./InstanceStats.vue?vue&type=template&id=105b9146&scoped=true&"
import script from "./InstanceStats.vue?vue&type=script&lang=ts&"
export * from "./InstanceStats.vue?vue&type=script&lang=ts&"
import style0 from "./InstanceStats.vue?vue&type=style&index=0&id=105b9146&lang=scss&scoped=true&"
import style1 from "./InstanceStats.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b9146",
  null
  
)

export default component.exports